import transpose from "./transpose.js";

export default function zip() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/zip.js
// module id = 437
// module chunks = 0